// import {useSelector} from "react-redux";
import { Navigate, Outlet } from 'react-router-dom';
const PrivateAdminRoute = () => {
  // const {userToken } = useSelector( state => state.authReducer );

  const userToken = localStorage.getItem('adminToken');
  return userToken ? <Outlet /> : <Navigate to="/login" />;
};
export default PrivateAdminRoute;
